import React from 'react';
import classNames from 'classnames'

import EventLink from '../EventLink'
import EventMetadata from '../EventMetadata'

import styles from './index.sass'

export default ({event, className, summary}) =>
    <section className={classNames(styles.root, {[styles.isSummary]: summary}, 'inverted', className)}>
        <div className="larger grid">
            <header className="column">
                <EventMetadata event={event} />
                {!summary
                    ? <h1>{event.title}</h1>
                    :
                        <EventLink className={styles.titleLink} event={event}>
                            <h2>{event.title}</h2>
                        </EventLink>
                }
            </header>
            {!summary && [
                <div key="details" className={classNames('medium-6 large-5 column', styles.details)}>
                    <ul>
                        {event.venue !== undefined &&
                            <li>
                                <b>Gdzie</b>
                                <span>{event.venue.name.short || event.venue.name.full}, {event.venue.location.address}</span>
                            </li>
                        }
                        {event.data && event.data.details !== undefined && event.data.details.map((detail, i) =>
                            <li key={i}>
                                <b>{detail.label}</b>
                                <div dangerouslySetInnerHTML={{ __html: detail.content }} />
                            </li>
                        )}
                    </ul>
                </div>,
                <div key="description" className={classNames('medium-6 large-7 column', styles.description)}>
                    <div className="g-type-major" dangerouslySetInnerHTML={{ __html: event.description }} />
                </div>
            ]}

            {!summary && <img />}
        </div>
    </section>


// WEBPACK FOOTER //
// ./src/modules/Events/elements/EventJumbo/index.js